import { Skeleton } from '@savvy-kit/components/skeleton';
import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import numeral from 'numeral';

import type { TextProps } from '@savvy-kit/foundations/text';
import { useIsSmallScreen } from '@savvy/deprecated-shared/hooks/use-is-small-screen';

function PortfolioTitleAmount({
  amount,
  variant,
  color,
  displayNetWorthAsWholeNumber,
}: {
  readonly amount: string | null;
  readonly variant: 'h4' | 'h5';
  readonly color?: TextProps['color'];
  readonly displayNetWorthAsWholeNumber?: boolean;
}) {
  const isSmallScreen = useIsSmallScreen();
  if (!amount) {
    return <Skeleton className="w-[150px] h-[60px]" />;
  }
  return (
    <div className={cn('flex flex-row items-end justify-start', isSmallScreen ? 'mt-0' : 'mt-1.5')}>
      {displayNetWorthAsWholeNumber ? (
        <Text variant="h4" color={color}>
          {numeral(amount).format('$0,0', Math.floor)}
        </Text>
      ) : (
        <>
          <Text variant="h4" className={isSmallScreen ? 'font-bold' : undefined} color={color}>
            {numeral(amount).format(isSmallScreen ? '$0,0.00' : '$0,0', Math.floor)}
          </Text>
          {!isSmallScreen && (
            <Text className={variant === 'h4' ? 'pb-1' : 'pb-0.5'} color={color}>
              {numeral(amount).format('.00')}
            </Text>
          )}
        </>
      )}
    </div>
  );
}

export default PortfolioTitleAmount;
